import examinationItemParser from './examinationItemParser';
import { ExaminationItem, ExaminationItemsParsed } from './types';

const mapExaminationItem = (data: ExaminationItem): ExaminationItemsParsed =>
  examinationItemParser(data);

export default mapExaminationItem;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/mapExaminationItem.ts